import * as Types from '../../../../__generated__/schema';

import { Notification } from '../../../graphql/fragments/Notification.generated';
import { GraphQLError } from 'graphql';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateUserNotificationsVariables = Types.Exact<{
  input: Types.UpdateUserNotificationsInput;
}>;

export type UpdateUserNotifications = {
  updateUserNotifications: { notifications: Array<Notification> };
};

export const UpdateUserNotificationsDocument = gql`
  mutation UpdateUserNotifications($input: UpdateUserNotificationsInput!) {
    updateUserNotifications(input: $input) {
      notifications {
        ...Notification
      }
    }
  }
  ${Notification}
`;
export type UpdateUserNotificationsMutationFn = Apollo.MutationFunction<
  UpdateUserNotifications,
  UpdateUserNotificationsVariables
>;

/**
 * __useUpdateUserNotifications__
 *
 * To run a mutation, you first call `useUpdateUserNotifications` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserNotifications` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserNotifications, { data, loading, error }] = useUpdateUserNotifications({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserNotifications(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateUserNotifications,
    UpdateUserNotificationsVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateUserNotifications, UpdateUserNotificationsVariables>(
    UpdateUserNotificationsDocument,
    options,
  );
}
export type UpdateUserNotificationsHookResult = ReturnType<typeof useUpdateUserNotifications>;
export type UpdateUserNotificationsMutationResult = Apollo.MutationResult<UpdateUserNotifications>;
export type UpdateUserNotificationsMutationOptions = Apollo.BaseMutationOptions<
  UpdateUserNotifications,
  UpdateUserNotificationsVariables
>;
export function mockUpdateUserNotifications({
  data,
  variables,
  errors,
}: {
  data: UpdateUserNotifications;
  variables?: UpdateUserNotificationsVariables;
  errors?: GraphQLError[];
}) {
  return {
    request: { query: UpdateUserNotificationsDocument, variables },
    result: { data, errors },
  };
}
